import * as React from 'react';

import LoadingIcon from '../../assets/Loading.svg';
import {Icon} from '../..';

type Props = React.HTMLAttributes<HTMLElement>;

export const Loading: React.FC<Props> = (props) => {
    return <Icon src={LoadingIcon} {...props} />;
};
